<template>
  <div class="card">
    <div class="card-header">
      Configurações específicas por tipo de pedido
    </div>
    <div class="card-body">

      <div class="row">
        <div class="col-12">

          <div class="card">
            <div class="card-header">
              Alocação
            </div>
            <div class="card-body">
              <div class="row px-md-0 px-3">
                <div class="col-auto pr-0">
                  <b-form-checkbox v-model="parameter.disableLotCreation"></b-form-checkbox>
                </div>
                <div class="col pl-0">
                  <label class="mb-0">Desabilitar a criação dos lotes através do WMS</label>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-12">

          <div class="card">
            <div class="card-header">
              Transferência
            </div>
            <div class="card-body">
              <div class="row px-md-0 px-3">
                <div class="col-auto pr-0">
                  <b-form-checkbox v-model="parameter.immediateTransferInboundRelease"></b-form-checkbox>
                </div>
                <div class="col pl-0">
                  <label>Liberação imediata de entrada de transferência</label>
                </div>
                <div class="col-12 ml-lg-0 ml-3">
                  <small class="text-muted">
                    Por padrão, quando uma transferência é sincronizada, apenas o pedido de saída é liberado.
                    De modo que o pedido de entrada só seja liberado após o primeiro movimento do pedido de saída.
                    Porém, se este parâmetro estiver marcado o pedido de entrada da transferência será liberado imediatamente após ser sincronizado.
                  </small>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-12">

          <div class="card">
            <div class="card-header">
              Ordem de Produção (OP)
            </div>
            <div v-if="parameter.wmsSyncValidations && parameter.wmsSyncValidations.PRODUCAO" class="card-body">
              <div class="row px-md-0 px-3">
                <div class="col-auto pr-0">
                  <b-form-checkbox v-model="parameter.wmsSyncValidations.PRODUCAO.enableSyncCancel"></b-form-checkbox>
                </div>
                <div class="col pl-0">
                  <label class="mb-0">Habilitar cancelamento via sincronização</label>
                </div>
                <div class="col-12">
                  <small class="text-muted">
                    Se marcado, ao sincronizar uma OP com situação "C" ela será marcada como cancelada no WMS
                  </small>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-12">

          <div class="card">
            <div class="card-header">
              Transformação
            </div>
            <div v-if="parameter.wmsSyncValidations && parameter.wmsSyncValidations.TRANSFORMACAO" class="card-body">

              <div class="row px-md-0 px-3">
                <div class="col-auto pr-0">
                  <b-form-checkbox v-model="parameter.wmsSyncValidations.TRANSFORMACAO.enableSyncCancel"></b-form-checkbox>
                </div>
                <div class="col pl-0">
                  <label class="mb-0">Habilitar cancelamento via sincronização</label>
                </div>
                <div class="col-12">
                  <small class="text-muted">
                    Se marcado, ao sincronizar uma transformação com situação "C" ela será marcada como cancelada no WMS
                  </small>
                </div>
              </div>

              <div
                v-for="tsf in transformationSituationFields"
                class="row px-md-0 px-3 mt-3"
                :key="'transformationSituationFields_' + tsf.key"
              >
                <div class="col">

                  <div class="px-md-0 px-3">
                    <label>{{tsf.label}}</label>
                    <multi-list-select
                      :list="transformationSituations"
                      :selectedItems="parameter.wmsSyncValidations.TRANSFORMACAO[tsf.key]"
                      option-value="value"
                      option-text="label"
                      placeholder="Selecione as situações"
                      @select="onTransformationSituationSelect(tsf.key, $event)"
                    ></multi-list-select>
                  </div>

                </div>
                <div class="col-12">
                  <small class="text-muted">
                    {{tsf.hint}}
                  </small>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import shared from '@/shared/shared';
import { MultiListSelect } from 'vue-search-select'

export default {
  name: 'order-type-specific-settings',
  components: { MultiListSelect },

  props: {
    parameter: {
      type: Object,
      require
    }
  },

  data() {
    return {
      transformationSituations: shared.TRANSFORMATION_SITUATIONS,
      transformationSituationFields: [
        {
          key: 'skipSyncSituations',
          label: 'Pular sincronização (incluindo atualizações) nas seguintes situações:',
          hint: 'Quando for sincronizada uma transformação nessas situações o sistema vai pular a sincronização para não substituir os dados anteriores da transformação do banco de dados em nuvem'
        },
        {
          key: 'partialSyncSituations',
          label: 'Executar sincronização parcial nas seguintes situações:',
          hint: 'Quando for sincronizada uma transformação nessas situações o sistema vai apenas atualizar o número e pular a sincronização padrão (que atualiza todos os dados)'
        },
        {
          key: 'syncAsPending',
          label: 'Sincronizar como pendente nas seguintes situações:',
          hint: 'Quando for sincronizada uma transformação nessas situações o sistema vai gerar/atualizar os pedidos dela como separação pendente (vai aparecer no WMS como pendente)'
        },
        {
          key: 'syncAsNotReleased',
          label: 'Sincronizar como não liberado para separação nas seguintes situações:',
          hint: 'Quando for sincronizada uma transformação nessas situações o sistema vai gerar/atualizar os pedidos dela como não liberado para separação. Ou seja, NÃO vai aparecer pra separar no WMS'
        }
      ]
    }
  },

  mounted() {
  },

  methods: {
    onTransformationSituationSelect(key, newValue) {
      let currentValue = this.parameter.wmsSyncValidations.TRANSFORMACAO[key];

      if (
        !currentValue ||
        newValue.length < currentValue.length || //Validar somente na inclusão, na remoção não
        this.validateNewValue(key, newValue)
      ) {
        this.parameter.wmsSyncValidations.TRANSFORMACAO[key] = newValue;
      } else {
        this.$notify.textError('Essa situação entra em conflito com as demais! Uma mesma situação não pode ter mais de um comportamento!');
      }
    },

    validateNewValue(key, newValue) {
      for (let obj of this.transformationSituationFields) {
        if (obj.key !== key) {
          let currentValue = this.parameter.wmsSyncValidations.TRANSFORMACAO[obj.key];

          if (currentValue && currentValue.length) {
            for (let nv of newValue) {
              let found = currentValue.find(cv => cv.value === nv.value);

              if (found) {
                return false;
              }
            }
          }
        }
      }

      return true;
    }
  }
}
</script>
